import React from "react";
import {usePrePlanOptions} from "./hooks/usePrePlanOptions";
import {IconDispute} from "@bounce/shared/ui";
import {IconLink, IconVerification} from "../../../../bounce-ui/assets";
import MenuItemDivider from "../../../../components/menus/MenuItemDivider";
import CustomMenuItem from "../../../../components/menus/CustomMenuItem";

const PrePlanOptions = () => {
  const {
    shouldDisplayPrePlanOptions,
    onContributionLinkClick,
    onDisputeClick,
    isDisputeButtonDisabled,
    onVerificationRequestClick,
  } = usePrePlanOptions();

  if (!shouldDisplayPrePlanOptions) return null;

  return (
    <>
      <CustomMenuItem
        onClick={onContributionLinkClick}
        label="Share contribution link"
        icon={<IconLink width={20} height={20} />}
      />
      <CustomMenuItem
        onClick={onVerificationRequestClick}
        label="Request debt verification"
        icon={<IconVerification width={20} height={20} />}
      />
      <CustomMenuItem
        onClick={onDisputeClick}
        label="Dispute This Debt"
        icon={<IconDispute width={20} height={20} />}
        disabled={isDisputeButtonDisabled}
      />
      <MenuItemDivider />
    </>
  );
};

export default PrePlanOptions;
